module.exports = __webpack_public_path__ + "static/media/dtron304kz.9c05302a.pdf";